import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import ContainedButton from "../../Components/Buttons/ContainedButton";
import { authLogger } from "../../Utils/logger";

export default function SignUp7() {
  const navigate = useNavigate();

  const handleGetStarted = useCallback(() => {
    authLogger.userAction("get_started_clicked");
    navigate("/dashboard");
  }, [navigate]);

  const handleBack = useCallback(() => {
    authLogger.userAction("back_to_notifications_clicked");
    navigate("/notification");
  }, [navigate]);
  return (
    <div
      className="onboarding-container"
      style={{ color: "rgba(230, 236, 241, 1)" }}
    >
      <div
        className="onboard-content"
        style={{
          alignItems: "center",
          textAlign: "center",
          justifyContent: "center",
        }}
      >
        <h1
          style={{ marginTop: "56px", marginBottom: "40px" }}
          className="text-heading-h3"
        >
          Get Started
        </h1>
        <div style={{ padding: "0px 20px" }}>
          <div>
            <img
              src="/icons/girl-image.svg"
              alt=""
              style={{ maxWidth: "358.28570556640625px", width: "100%" }}
            />
          </div>
          <div
            className="d-flex flex-column flex-sm-row gap-3 gap-sm-4 terms-buttons justify-content-center align-items-center w-100"
            style={{ marginTop: "40px", marginBottom: "44px" }}
          >
            <ContainedButton
              style={{ maxWidth: 160, width: "100%" }}
              className={`btn-1 btn-1-basic`}
              onClick={handleBack}
            >
              Back
            </ContainedButton>
            <ContainedButton
              onClick={handleGetStarted}
              className="btn-1"
              style={{
                backgroundColor: "rgba(0, 140, 255, 1)",
                color: "rgba(230, 236, 241, 1)",
                border: "1.5px solid rgba(0, 140, 255, 1)",
                maxWidth: "160px",
                width: "100%",
                cursor: "pointer",
              }}
            >
              Get Started
            </ContainedButton>
          </div>
        </div>
      </div>
    </div>
  );
}
